import type { AvailableContext } from './api.js';

/// Como cada lugar de atuação aparece para a pessoa (ADR 0067). "Cliente" é de toda conta e vem
/// primeiro; empresa e plataforma dependem de acesso concedido.
export function contextKey(context: AvailableContext): string {
  return context.kind === 'TENANT_MEMBER' ? context.membershipId : context.kind;
}

export function contextTitle(context: AvailableContext): string {
  if (context.kind === 'CUSTOMER') return 'Entrar como cliente';
  return context.kind === 'PLATFORM' ? context.label : context.displayName;
}

export function contextSubtitle(context: AvailableContext): string {
  if (context.kind === 'CUSTOMER') return 'Seus agendamentos em todas as empresas';
  return context.kind === 'PLATFORM' ? 'Console global' : 'Área administrativa da empresa';
}

/// O pedido de troca que o servidor entende.
export function contextTarget(
  context: AvailableContext,
): { kind: 'CUSTOMER' } | { kind: 'PLATFORM' } | { kind: 'TENANT_MEMBER'; tenantId: string } {
  return context.kind === 'TENANT_MEMBER'
    ? { kind: 'TENANT_MEMBER', tenantId: context.tenantId }
    : { kind: context.kind };
}
